<template>
  <div id="app">
    <app-header></app-header>
    <router-view />
    <app-footer></app-footer>
    <transition name="fadevideobox">
      <app-videoplayer
        v-if="videoCinemaState || videoCinemaPreviewItem"
      ></app-videoplayer>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import Header from "@/components/Header/";
import Footer from "@/components/Footer/";
import Videoplayer from "@/components/Videoplayer/";
import { mapGetters } from "vuex";

axios.defaults = {
  baseURL: process.env.VUE_APP_URL
};

export default {
  name: "App",
  data: function() {
    return {
      test: false
    };
  },
  computed: {
    ...mapGetters(["videoCinemaState", "videoCinemaPreviewItem", "language"])
  },
  components: {
    appHeader: Header,
    appFooter: Footer,
    appVideoplayer: Videoplayer
  },
  methods: {
  },
  created() {
    this.$store.dispatch("setInitial");

    //load initial data
    axios
      .get(process.env.VUE_APP_URL + `data/topics_${this.language}.json`, {})
      .then(res => {


        let addPathPrefix = (url) => {
          return process.env.VUE_APP_MULTIMEDIA_FOLDER + url;
        }

        //add variable ruta archivos multimedia
        res.data.videoHeader.forEach((el)=>{
          el.urlVideo = addPathPrefix(el.urlVideo);
          el.urlVideoMobile = addPathPrefix(el.urlVideoMobile);
          el.posterVideoMobile = addPathPrefix(el.posterVideoMobile);
        });

        //add variable ruta archivos multimedia
        res.data.videos.forEach((el)=>{
          el.thumb = addPathPrefix(el.thumb);
          el.thumb_mobile = addPathPrefix(el.thumb_mobile);
          el.url_video = addPathPrefix(el.url_video);
          el.video_poster = addPathPrefix(el.video_poster);
        });

        this.$store.dispatch("initTopics", res.data);
        this.$store.dispatch("initHeader", res.data.videoHeader);
      });
  }
};
</script>

<style src="@/scss/style.scss" lang="scss"></style>
